// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"868de757","513":"0fd0ca2d","703":"995d5e51"}[chunkId] + ".chunk.js";
};